import disputeRepository from '@/domain/repository/DisputeRepository';
import {Dispute, toDomain, toDto} from '@/domain/entities/Dispute';

export const updateDispute = async (dispute: Dispute): Promise<Dispute | undefined> => {
  try {
    if(!dispute) return undefined;

    const dto = toDto(dispute);

    const result = await disputeRepository.updateDispute(dto);
    return result ? toDomain(result) : undefined;

  } catch (error) {
    console.error('Error updating dispute', error);
    return Promise.reject(dispute);
  }
};